import { buildMeta, getCompanyFromMatches } from "~/utils/meta-helpers";

import { AboutLaunchSection } from "../components/HomeSections/AboutLaunchSection";

import type { MetaFunction } from "@remix-run/node";

export const meta: MetaFunction = ({ matches }) => {
  const company = getCompanyFromMatches(matches);
  return buildMeta({
    title: `Quiénes somos | ${company}`,
    description:
      "Trabajamos con IA todos los días. Por eso podemos explicártela fácil: sin tecnicismos, " +
      "sin humo y desde el escalón cero.",
    path: "/quienes-somos",
  });
};

/**
 * "Quiénes somos" como página propia.
 *
 * Es EXACTAMENTE la misma sección que vivía en la Home: se importa el componente, no se
 * copia su markup. Cualquier cambio en AboutLaunchSection se refleja acá sin tocar nada,
 * y no hay dos versiones que se puedan desincronizar.
 *
 * El componente ya trae su propio <section> con fondo, padding y el id `quienes-somos`,
 * así que la página no envuelve nada: sumar un contenedor cambiaría el espaciado que
 * Rodrigo pidió conservar tal cual.
 */
export default function QuienesSomosPage() {
  return <AboutLaunchSection />;
}
